import useSWR from 'swr';
import {
  engagementLeadTypes,
  hotProspectLeadTypes, IDeliveredTouchStat, IEmailDeliverabilityStats, ILeadResponseStats,
} from 'types/stats';

export const useCampaignDeliveredTouchStats = (campaignId: string) => {
  const { data, error } = useSWR<IDeliveredTouchStat[]>(`/campaigns/stats/delivered-touches/${campaignId}`);

  return {
    deliveredTouchStats: data,
    isLoadingDeliveredTouchStats: !data,
    isLoadingDeliveredTouchStatsError: error,
  };
};

export const useCampaignLeadResponseStats = (campaignId?: string) => {
  // Gets lead responses for all user's campaigns if campaignId is ommitted
  const url = campaignId
    ? `/campaigns/stats/lead-responses/${campaignId}`
    : '/campaigns/stats/lead-responses';

  const { data, error } = useSWR<ILeadResponseStats>(url);

  return {
    leadResponseStats: data,
    isLoadingLeadResponseStats: !data,
    isLoadingLeadResponseStatsError: error,
  };
};

export const useCampaignEmailDeliverabilityStats = (campaignId: string) => {
  const { data, error } = useSWR<IEmailDeliverabilityStats>(`/campaigns/stats/email-deliverability/${campaignId}`);

  return {
    emailDeliverabilityStats: data,
    isLoadingEmailDeliverabilityStats: !data,
    isLoadingEmailDeliverabilityStatsError: error,
  };
};

export const reduceNumHotProspects = (leadResponseStats: ILeadResponseStats): number => {
  // We only want to show the # of unique hot prospects, not just the # of events unlike the engagements
  // stat. We therefore group these by the apn and show that #
  // return hotProspectLeadTypes.reduce((sum, leadResponseType) => (sum + leadResponseStats[leadResponseType].length), 0);
  const hotProspectApns = hotProspectLeadTypes.reduce<Set<string>>((set, leadResponseType) => {
    leadResponseStats[leadResponseType].forEach((leadResponse) => {
      if (leadResponse.eventData) set.add(leadResponse.eventData?.apn);
    });

    return set;
  },
  new Set());

  return hotProspectApns.size;
};

export const reduceNumEngagements = (leadResponseStats: ILeadResponseStats): number => engagementLeadTypes.reduce<number>(
  (sum, leadResponseType) => (sum + leadResponseStats[leadResponseType].length),
  0,
);
